﻿const toBase64 = (value: string) => {
    const bytes = new TextEncoder().encode(value);
    return btoa(String.fromCharCode(...bytes));
};

const fromBase64 = (base64: string) => {
    const binary = atob(base64);
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
    return new TextDecoder().decode(bytes);
};

const isBase64 = (value: string) => {
    try {
        return toBase64(fromBase64(value)) === value;
    } catch {
        return false;
    }
};

export { toBase64, fromBase64 };
export default isBase64;
